export class LocalStorageConstants {
    public static readonly IS_DELIVERY_MANAGER = "isDeliveryManager";
}